import * as yup from "yup";
import {
  decimalStringTest,
  isValidDateTest,
  maxLengthMessage,
} from "../../../utils/functions";
import moment from "moment";
import { RegularExpressions } from "../../../utils/regular-expressions";

const courseSchema = yup.object().shape({
  courseName: yup
    .string()
    .trim()
    .matches(RegularExpressions.Name, "Invalid Course Title")
    .max(50, maxLengthMessage(50))
    .required("Course Title is required")
    .nonNullable(),
  courseBeginDate: isValidDateTest("Course Begin Date"),
  courseEndDate: isValidDateTest("Course End Date").when(
    "courseBeginDate",
    (start, schema) => {
      if (!start) return schema;
      return schema.test(
        "is-after-start",
        "Course End Date must be the same or after Course Begin Date",
        (end) => {
          if (!end) return true;
          const startDate = moment(start, "MM/DD/YYYY", true);
          const endDate = moment(end, "MM/DD/YYYY", true);
          return endDate.isSameOrAfter(startDate);
        }
      );
    }
  ),
  location: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  hours: yup
    .number()
    .transform((value, originalValue) => {
      // Convert empty string to null
      return originalValue === "" ? null : Number(originalValue);
    })
    .nullable()
    .positive()
    .integer(),
  category: yup.string().trim().max(50, maxLengthMessage(50)).required("Category is required").nonNullable(),
  approved: yup.boolean().nullable(),
  courseNumber: yup
    .string()
    .trim()
    .matches(RegularExpressions.ID, "Invalid Course Number")
    .max(100, maxLengthMessage(100))
    .required("Course Number is required")
    .nonNullable(),
  instructor: yup.string().trim().matches(RegularExpressions.Name, "Invalid Instructor Name").max(50, maxLengthMessage(50)).nullable(),
  certification: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  expireDate: isValidDateTest("Expiration Date"),
  certificationEntered: yup.boolean().nullable(),
  tuitionDefault: decimalStringTest("Tuition Default Cost", 15, 2),
});

export default courseSchema;
